import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CloseIcon from "@mui/icons-material/Close";
import TimePicker from "rc-time-picker";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { useGlobalContext } from "../../../Context/GlobalContext";
import PresentAndHalfDayModal from "../../../components/Edit_Staff/PresentAndHalfDayModal";
import Modal from "react-responsive-modal";
import ClipLoader from "react-spinners/ClipLoader";
import Cookies from "js-cookie";
const ConfirmationModal = ({ setStatus, status, updateStatus }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleUpdateStatus = async () => {
    try {
      setIsLoading(true); // Start the loading state
      await updateStatus(status); // Call the async function
    } catch (error) {
      console.error("Error updating status:", error);
    } finally {
      setIsLoading(false); // End the loading state
      setStatus(""); // Close the modal after update
    }
  };

  return (
    <Modal
      open={
        status === "PRESENT" ||
        status === "HALFDAY" ||
        status === "ABSENT" ||
        status === "PAIDLEAVE"
      }
      onClose={() => setStatus("")}
      center
    >
      <div className="pt-5">
        <div className="relative p-4 pr-0 pl-0 text-center">
          <div>
            <h2 className="font-bold text-[#130025] text-[20px]">
              Sure You Want To Accept?
            </h2>
            <p>Are you sure you want to accept this?</p>
          </div>
        </div>

        <div className="flex justify-around">
          <button
            onClick={handleUpdateStatus}
            className={`second-btn ${isLoading ? "opacity-50 cursor-not-allowed" : ""
              }`}
            disabled={isLoading} // Disable the button while loading
          >
            {isLoading ? "Processing..." : "Confirm"}
          </button>
          <button
            className="second-btn"
            onClick={() => setStatus("")}
            disabled={isLoading} // Disable cancel while loading to avoid interruptions
          >
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

const StaffSalarySummry = () => {
  const { id } = useParams();
  // console.log(id)
  const [commonStatus, setCommonStatus] = useState("");
  const {
    baseUrl,
    selectedStaff,
    openToast,
    shift: allShift,
  } = useGlobalContext();
  console.log(selectedStaff)
  const [totalOvertime, setTotalOvertime] = useState(null);
  const [punchId, setPunchId] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [punchDate, setPunchDate] = useState("");
  console.log(punchDate)
  const [fine, setFine] = useState({
    staffId: selectedStaff?.staffDetails?.id,
    lateEntryHour: "",
    excessBreakHour: "",
    earlyOutHour: "",
    lateEntryFineAmount: 0,
    lateEntryAmount: 1,
    excessBreakFineAmount: 0,
    excessBreakAmount: 1,
    earlyOutFineAmount: 0,
    earlyOutAmount: 1,
    shiftIds: "",
  });

  function formatDate(date) {
    return date
      .toLocaleDateString("en-US", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/,/, ","); // Add a comma after the month
  }

  // console.log(punchId);
  // Function to open the modal
  const openModal = () => {
    setIsOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsOpen(false);
  };

  const [isOpen2, setIsOpen2] = useState(false);

  // Function to open the modal 2
  const openModal2 = () => {
    setIsOpen2(true);
  };

  // Function to close the modal 2
  const closeModal2 = () => {
    setIsOpen2(false);
  };

  //salary2 dropdown
  const [isOpen3, setIsOpen3] = useState(false);

  const toggleDropdown3 = () => {
    setIsOpen3(!isOpen3);
  };

  //salary2 dropdown

  // Function to open the modal 6

  const [isOpen6, setIsOpen6] = useState(false);
  const openModal6 = () => {
    setIsOpen6(true);
  };

  // Function to close the modal 6
  const closeModal6 = () => {
    setIsOpen6(false);
  };

  //salary2 dropdown
  const [isOpen9, setIsOpen9] = useState(false);

  const toggleDropdown9 = () => {
    setIsOpen9(!isOpen9);
  };

  //salary2 dropdown

  // Function to open the modal 7

  const [isOpen0, setIsOpen0] = useState(false);
  const openModal0 = () => {
    setIsOpen0(true);
  };

  // Function to close the modal 7
  const closeModal0 = () => {
    setIsOpen0(false);
  };

  // Function to open the modal 12

  const [isOpen12, setIsOpen12] = useState(false);
  const openModal12 = () => {
    setIsOpen12(true);
  };

  // Function to close the modal 12
  const closeModal12 = () => {
    setIsOpen12(false);
  };

  // Function to open the modal 14

  const [isOpen14, setIsOpen14] = useState(false);
  const openModal14 = () => {
    setIsOpen14(true);
  };

  // Function to close the modal 14
  const closeModal14 = () => {
    setIsOpen14(false);
  };
  const [selectedMonth, setSelectedMonth] = useState(() => {
    const currentMonth = new Date();
    return {
      original: currentMonth.toISOString().slice(0, 7), // Keep as YYYY-MM
      formatted: `${currentMonth.toLocaleString("default", {
        month: "short",
      })}, ${currentMonth.getFullYear()}`, // Oct, 2024
    };
  });

  // Function to handle previous month click
  const handlePrevMonth = () => {
    const currentMonthDate = new Date(`${selectedMonth.original}-01`); // Append "-01" for valid date
    currentMonthDate.setMonth(currentMonthDate.getMonth() - 1);

    setSelectedMonth({
      original: currentMonthDate.toISOString().slice(0, 7), // Keep in YYYY-MM
      formatted: `${currentMonthDate.toLocaleString("default", {
        month: "short",
      })}, ${currentMonthDate.getFullYear()}`, // Oct, 2024
    });
  };

  // Function to handle next month click
  const handleNextMonth = () => {
    const currentMonthDate = new Date(`${selectedMonth.original}-01`); // Append "-01" for valid date
    currentMonthDate.setMonth(currentMonthDate.getMonth() + 1);

    setSelectedMonth({
      original: currentMonthDate.toISOString().slice(0, 7), // Keep in YYYY-MM
      formatted: `${currentMonthDate.toLocaleString("default", {
        month: "short",
      })}, ${currentMonthDate.getFullYear()}`, // Oct, 2024
    });
  };

  const [date, setDate] = useState();

  const [attendanceRecord, setAttendanceRecord] = useState([]);
  async function fetchAttendanceSummary() {
    setIsLoading(true);
    try {
      const response = await fetch(
        baseUrl +
        `attendance/single/${selectedStaff?.staffDetails?.id
        }?type=month&date=${selectedMonth?.original
          ?.split("-")
          ?.reverse()
          ?.join("/")}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
          },
        }
      );
      const result = await response.json();

      if (response.status === 200) {
        console.log(result);
        setAttendanceRecord(result?.attendanceRecords);
      } else {
        console.log(result);
      }
    } catch (error) {
      console.error("Error creating and updating attendance mode:", error);
    } finally {
      setIsLoading(false);
    }
  }

  function formatDate(isoString) {
    const date = new Date(isoString);

    const day = date.toLocaleDateString("en-GB", { day: "2-digit" });
    const month = date.toLocaleDateString("en-GB", { month: "short" });
    const weekday = date.toLocaleDateString("en-GB", { weekday: "short" });

    return `${day} ${month} | ${weekday}`;
  }

  // console.log(selectedMonth);
  // console.log(shiftDetails);
  const [isLoading, setIsLoading] = useState(false);

  async function updateAttendanceStatus(commmenStatus) {
    setIsLoading(true);
    try {
      if (commmenStatus === "") {
        openToast("Please Select Status", "error");
        return;
      }

      // console.log(commmenStatus);

      const result = await fetch(baseUrl + `attendance/status/${punchId}`, {
        method: "PATCH",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({ status: commmenStatus }),
      });
      if (result.status == 200) {
        openToast("Updated Status Successfully", "success");
        setAttendanceRecord([]);
        fetchAttendanceSummary();
      } else {
        openToast("Something went wrong", "error");
      }
    } catch (error) {
      openToast("Something went wrong", "error");
    } finally {
      setIsLoading(false);
      if (commmenStatus === "PRESENT") {
        closeModal6();
      }
      if (commmenStatus === "ABSENT") {
        closeModal();
      }
      if (commmenStatus === "HALFDAY") {
        closeModal2();
      }
      if (commmenStatus === "PAIDLEAVE") {
        closeModal14();
      }
    }
  }
  async function updatePresentAndHalfDayAttendace(punchID, data) {
    try {
      if (data.status === "") {
        openToast("Please Select Status", "error");
        return;
      }

      const result = await fetch(baseUrl + `attendance/status/${punchID}`, {
        method: "PATCH",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify(data),
      });
      if (result.status == 200) {
        openToast("Update " + data?.status + " Status Successfully", "success");
        setAttendanceRecord([]);
        fetchAttendanceSummary();
      } else {
        openToast("Something went wrong", "error");
      }
    } catch (error) {
      openToast("Something went wrong", "error");
    } finally {
      setIsLoading(false);
      if (data.status === "PRESENT") {
        closeModal6();
      }
      if (data.status === "HALFDAY") {
        closeModal2();
      }
    }
  }
  async function createFine() {
    setIsLoading(true);
    try {
      const result = await fetch(baseUrl + `fine/create`, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({
          punchRecordId: punchId,
          staffId: selectedStaff?.staffDetails?.id,
          // shiftIds: fine?.shiftIds ? [fine?.shiftIds] : [],
          lateEntryFineAmount:
            Number(fine.lateEntryFineAmount) * Number(fine.lateEntryAmount),
          lateEntryAmount: Number(fine.lateEntryAmount),
          lateEntryFineHoursTime: fine.lateEntryHour,
          excessBreakFineAmount:
            Number(fine.excessBreakFineAmount) * Number(fine.excessBreakAmount),
          excessBreakAmount: Number(fine.excessBreakAmount),
          excessBreakFineHoursTime: fine.excessBreakHour,
          earlyOutFineAmount:
            Number(fine.earlyOutFineAmount) * Number(fine.earlyOutAmount),
          earlyOutAmount: Number(fine.earlyOutAmount),
          earlyOutFineHoursTime: fine.earlyOutHour,
          totalAmount:
            Number(fine.lateEntryFineAmount) * Number(fine.lateEntryAmount) +
            Number(fine.excessBreakFineAmount) *
            Number(fine.excessBreakAmount) +
            Number(fine.earlyOutFineAmount) * Number(fine.earlyOutAmount),
        }),
      });
      if (result.ok) {
        openToast("Create Fine Successfully", "success");
        setFine({
          staffId: selectedStaff?.staffDetails?.id,
          lateEntryHour: "",
          excessBreakHour: "",
          earlyOutHour: "",
          lateEntryFineAmount: 0,
          lateEntryAmount: 1,
          excessBreakFineAmount: 0,
          excessBreakAmount: 1,
          earlyOutFineAmount: 0,
          earlyOutAmount: 1,
          shiftIds: "",
        });
        setPunchId("");
        if (!isLoading) {
          fetchAttendanceSummary();
          setAttendanceRecord([]);
        }
      } else {
        openToast("Something went wrong", "error");
      }
    } catch (error) {
      openToast("Something went wrong", "error");
    } finally {
      setIsLoading(false);
      closeModal0();
    }
  }
  const [overTime, setOverTime] = useState({
    staffId: selectedStaff?.staffDetails?.id,
    lateEntryHour: "",
    earlyOutHour: "",
    lateEntryFineAmount: 0,
    lateEntryAmount: 1,
    earlyOutFineAmount: 0,
    earlyOutAmount: 1,
    shiftIds: "",
  });
  console.log(overTime);
  async function createOvertime() {
    setIsLoading(true);
    try {
      // console.log(commmenStatus);

      const result = await fetch(baseUrl + `overtime/create`, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({
          punchRecordId: punchId,
          staffId: selectedStaff?.staffDetails?.id,
          lateOutAmount:
            Number(overTime?.lateEntryFineAmount) *
            Number(overTime?.lateEntryAmount),
          lateOutOvertimeAmount: Number(overTime?.lateEntryAmount),
          lateOutOvertimeHoursTime: overTime?.lateEntryHour,
          earlyEntryAmount:
            Number(overTime?.earlyOutFineAmount) *
            Number(overTime?.earlyOutAmount),
          earlyCommingEntryAmount: Number(overTime?.earlyOutAmount),
          earlyCommingEntryHoursTime: overTime?.earlyOutHour,
          // shiftIds: overTime?.shiftIds,
          totalAmount:
            Number(overTime.lateEntryFineAmount) *
            Number(overTime.lateEntryAmount) +
            Number(overTime.earlyOutFineAmount) *
            Number(overTime.earlyOutAmount),
        }),
      });
      if (result.ok) {
        openToast("Create Overtime Fine Successfully", "success");
        setOverTime({
          staffId: selectedStaff?.staffDetails?.id,
          lateEntryHour: "",
          earlyOutHour: "",
          lateEntryFineAmount: 0,
          lateEntryAmount: 1,
          earlyOutFineAmount: 0,
          earlyOutAmount: 1,
          shiftIds: "",
        });
        setPunchId("");
        if (!isLoading) {
          fetchAttendanceSummary();
          setAttendanceRecord([]);
        }
      } else {
        openToast("Something went wrong", "error");
      }
    } catch (error) {
      openToast("Something went wrong", "error");
    } finally {
      closeModal12();
      setIsLoading(false);
    }
  }
  function calculateFinePerMinute(
    monthlySalary,
    workingDays,
    workingHoursPerDay
  ) {
    if (monthlySalary <= 0 || workingDays <= 0 || workingHoursPerDay <= 0) {
      throw new Error("All inputs must be greater than zero.");
    }
    const finePerMinute =
      monthlySalary / (workingDays * workingHoursPerDay * 60);
    return finePerMinute.toFixed(2);
  }
  function calculateTotalTime(type, attendanceRecords) {
    // Helper function to convert HH:mm to minutes
    const timeToMinutes = (timeStr) => {
      if (!timeStr) return 0; // Handle null or undefined time strings
      const [hours, minutes] = timeStr.split(":").map(Number);
      return hours * 60 + minutes;
    };

    // Initialize total overtime in minutes
    let totalTime = 0;

    // Iterate through attendance records and calculate total overtime
    attendanceRecords?.forEach((record) => {
      if (type === "overtime") {
        const earlyMinutes = timeToMinutes(
          record?.Overtime?.earlyCommingEntryHoursTime
        );
        const lateMinutes = timeToMinutes(
          record?.Overtime?.lateOutOvertimeHoursTime
        );
        totalTime += earlyMinutes + lateMinutes;
      }
      if (type === "fine") {
        const lateEntryMinutes = timeToMinutes(
          record?.Fine?.lateEntryFineHoursTime
        );
        const earlyOutMinutes = timeToMinutes(
          record?.Fine?.earlyOutFineHoursTime
        );
        const excessBreakMinutes = timeToMinutes(
          record?.Fine?.excessBreakFineHoursTime
        );
        totalTime += lateEntryMinutes + earlyOutMinutes + excessBreakMinutes;
      }
    });

    // Convert total minutes back to HH:mm format
    const hours = Math.floor(totalTime / 60);
    const minutes = totalTime % 60;

    return {
      totalTime,
      formatedTime: `${hours} hr ${minutes} min`,
    };
  }

  const calcTimeDiff = (record) => {
    const punchInTime = record?.punchIn?.punchInTime;
    const punchOutTime = record?.punchOut?.punchOutTime;

    if (punchInTime && punchOutTime) {
      const inTime = new Date(punchInTime);
      const outTime = new Date(punchOutTime);

      // Calculate time difference in milliseconds
      const diffInMs = outTime - inTime;

      // Convert milliseconds to hours and minutes
      const hours = Math.floor(diffInMs / (1000 * 60 * 60));
      const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));

      // Format the difference as "HH:mm"
      return `${hours}:${minutes.toString().padStart(2, "0")}`;

      // Save to state
    } else {
      return "0:00"; // Default if times are not available
    }
  };

  useEffect(() => {
    setAttendanceRecord([]);
    fetchAttendanceSummary();
  }, [selectedMonth]);
  // console.log(fine, overTime);
  return (
    <div className="relative flex flex-col xl:pt-[30px] pb-[30px] w-full">
      {isOpen6 && (
        <PresentAndHalfDayModal
          type={"PRESENT"}
          modalHeading={`${selectedStaff?.name} | ${punchDate}`}
          isOpenModal={isOpen6}
          isCloseModal={closeModal6}
          punchRecordId={punchId}
          updateStatus={updatePresentAndHalfDayAttendace}
          fetchAttendanceSummary={fetchAttendanceSummary}
        />
      )}
      {isOpen2 && (
        <PresentAndHalfDayModal
          type={"HALFDAY"}
          modalHeading={`${selectedStaff?.name} | ${punchDate}`}
          isOpenModal={isOpen2}
          isCloseModal={closeModal2}
          punchRecordId={punchId}
          updateStatus={updatePresentAndHalfDayAttendace}
          fetchAttendanceSummary={fetchAttendanceSummary}
        />
      )}
      {(commonStatus === "PRESENT" ||
        commonStatus === "HALFDAY" ||
        commonStatus === "ABSENT" ||
        commonStatus === "PAIDLEAVE") && (
          <ConfirmationModal
            updateStatus={updateAttendanceStatus}
            setStatus={setCommonStatus}
            status={commonStatus}
          />
        )}

      <div className="top-0 flex justify-between items-center bg-white shadow-cs pt-[14px] pr-[14px] pb-[14px] pl-[14px] rounded-md w-[100%]">
        <div className="flex items-center gap-[10px]">
          <h1 className="font-medium capitalize">{selectedStaff?.name}</h1>
        </div>

        <button className="second-btn">Download Report</button>
      </div>

      <div className="shadow mt-[24px] p-[20px] rounded-md">
        <div className="flex sm:flex-row md:flex-row lg:flex-row xl:flex-row flex-col justify-between xl:items-center gap-[14px]">
          <div className="flex">
            {/* <input className='bg-transparent font-medium text-[14px]' type="date" /> */}
            <div className="flex items-center gap-4">
              <ArrowBackIosIcon
                onClick={handlePrevMonth}
                className="arrow-icon-back"
              />
              <h2>{selectedMonth.formatted}</h2>
              <ArrowForwardIosIcon
                onClick={handleNextMonth}
                className="arrow-icon-back"
              />
            </div>
          </div>
          <div className="flex xl:flex-row flex-col justify-between lg:items-end xl:items-center gap-[14px]">
            <h2 className="font-medium text-[14px]">
              Total Pending for Approval :{" "}
              <span className="text-[#ff0000]">
                {
                  attendanceRecord?.filter((item) => item?.isApproved === false)
                    ?.length
                }
              </span>
            </h2>
          </div>
        </div>
        <div className="">
          <div className="flex flex-wrap gap-[18px] mt-[16px] whitespace-nowrap summaryrecord">
            <div className="total-staff">
              <h2 className="font-normal text-[#000000bf] text-[14px]">Day</h2>
              <p className="font-medium text-[14px]">
                {attendanceRecord?.length}
              </p>
            </div>
            <div className="total-staff">
              <h2 className="font-normal text-[#000000bf] text-[14px]">
                Present
              </h2>
              <p className="font-medium text-[14px]">
                {
                  attendanceRecord?.filter(
                    (record) => record?.status === "PRESENT"
                  )?.length
                }
              </p>
            </div>
            <div className="total-staff">
              <h2 className="font-normal text-[#000000bf] text-[14px]">
                Absent
              </h2>
              <p className="font-medium text-[14px]">
                {
                  attendanceRecord?.filter(
                    (record) => record?.status === "ABSENT"
                  )?.length
                }
              </p>
            </div>
            <div className="total-staff">
              <h2 className="font-normal text-[#000000bf] text-[14px]">
                Half Day
              </h2>
              <p className="font-medium text-[14px]">
                {
                  attendanceRecord?.filter(
                    (record) => record?.status === "HALFDAY"
                  )?.length
                }
              </p>
            </div>
            <div className="total-staff">
              <h2 className="font-normal text-[#000000bf] text-[14px]">
                Overtime Hours
              </h2>
              <p className="font-medium text-[14px]">
                {attendanceRecord?.length > 0
                  ? calculateTotalTime("overtime", attendanceRecord)
                    ?.formatedTime
                  : "00:00"}
              </p>
            </div>
            <div className="total-staff">
              <h2 className="font-normal text-[#000000bf] text-[14px]">
                Fine Hours
              </h2>
              <p className="font-medium text-[14px]">
                {attendanceRecord?.length > 0
                  ? calculateTotalTime("fine", attendanceRecord)?.formatedTime
                  : "00:00"}
              </p>
            </div>
          </div>
        </div>
      </div>
      {!isLoading && attendanceRecord?.length === 0 && (
        <div className="flex justify-center items-center py-4 w-full h-full">
          <h1 className="font-normal text-red-600 text-lg">
            No records found! Please add a salary or shift for {selectedStaff?.name} to proceed.
          </h1>
        </div>
      )}
      {attendanceRecord?.length > 0 && isLoading === false && (
        attendanceRecord?.map((record) => {
          return (
            <div
              key={record?.id}
              className="shadow shadow-cs mt-[20px] p-[20px] rounded-md"
            >
              <div className="flex md:flex-row lg:flex-row xl:flex-row flex-col justify-between items-start md:items-start gap-4 md:gap-0 lg:gap-0 xl:gap-0">
                <div>
                  <h2 className="text-[16px] whitespace-nowrap">
                    {formatDate(record.punchDate)}
                  </h2>
                  <p className="font-normal text-[#9d9d9d] text-[14px] whitespace-nowrap">
                    {calcTimeDiff(record)} Hrs
                  </p>
                  <p className="font-normal text-[#9d9d9d] text-[14px] whitespace-nowrap">
                    {record?.shift?.shiftName} (
                    {record?.punchIn?.punchInTime
                      ? new Date(record.punchIn.punchInTime).toLocaleTimeString(
                        "en-US",
                        {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        }
                      )
                      : "N/A"}
                    -{" "}
                    {record?.punchOut?.punchOutTime
                      ? new Date(
                        record?.punchOut?.punchOutTime
                      ).toLocaleTimeString("en-US", {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })
                      : "N/A"}
                    )
                  </p>
                  {/* <p className="mt-[10px] font-medium text-[#8a25b0] text-[14px]">
                    Add Note - Login
                  </p> */}
                </div>
                <div className="flex flex-row md:flex-col lg:flex-col xl:flex-col justify-between md:justify-start lg:justify-start xl:justify-start gap-[18px] w-full set-workd">
                  <div className="flex md:flex-row lg:flex-row xl:flex-row flex-col md:justify-end lg:justify-end xl:justify-end gap-[20px] w-[50%] md:w-full xl:w-full">
                    {/* Button to open modal */}
                    <button
                      onClick={() => {
                        setPunchDate(formatDate(record.punchDate))
                        setPunchId(record?.id);
                        if (record?.status !== "PRESENT") {
                          openModal6();
                        } else {
                          setCommonStatus("PRESENT");
                        }
                      }}
                      className={
                        " btns px-6 py-3 text-[14px] font-medium rounded-md focus:outline-none w-full xl:w-[200px] lg:w-[142px] md:w-[140px] whitespace-nowrap shadow-md " +
                        (record?.status === "PRESENT"
                          ? "bg-[#008000] text-white"
                          : "bg-white text-black")
                      }
                    >
                      P I{" "}
                      {record?.status === "PRESENT"
                        ? `${record?.punchIn?.punchInTime
                          ? new Date(
                            record?.punchIn?.punchInTime
                          ).toLocaleTimeString("en-IN", {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })
                          : "N/A"
                        } - ${record?.punchOut?.punchOutTime
                          ? new Date(
                            record?.punchOut?.punchOutTime
                          ).toLocaleTimeString("en-IN", {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })
                          : "N/A"
                        }`
                        : "PRESENT"}
                    </button>

                    {/* Modal overlay and content */}

                    {/* Button to open modal */}
                    <button
                      onClick={() => {
                        setPunchDate(formatDate(record.punchDate))
                        setPunchId(record?.id);
                        if (record?.status !== "HALFDAY") {
                          openModal2();
                        } else {
                          setCommonStatus("HALFDAY");
                        }
                      }}
                      className={
                        " btns px-6 py-3 text-[14px] font-medium rounded-md focus:outline-none w-full xl:w-[200px] lg:w-[142px] md:w-[140px] whitespace-nowrap shadow-md  " +
                        (record?.status === "HALFDAY"
                          ? "bg-[#008000] text-white"
                          : "bg-white text-black")
                      }
                    >
                      HD I HalfDay
                    </button>

                    {/* Modal overlay and content */}

                    {/* Button to open modal */}
                    <button
                      onClick={() => {
                        setDate(record?.punchDate);
                        setPunchId(record?.id);
                        openModal0();

                        console.log(record);
                        setFine({
                          ...fine,
                          earlyOutAmount: record?.fine?.earlyOutAmount || 1,
                          earlyOutFineAmount:
                            record?.fine?.earlyOutFineAmount /
                            (record?.fine?.earlyOutAmount || 1) || 0,
                          earlyOutHour:
                            record?.fine?.earlyOutFineHoursTime || "00:00",
                          lateEntryAmount: record?.fine?.lateEntryAmount || 1,
                          lateEntryFineAmount:
                            record?.fine?.lateEntryFineAmount /
                            (record?.fine?.lateEntryAmount || 1) || 0,
                          lateEntryHour:
                            record?.fine?.lateEntryFineHoursTime || "00:00",
                          excessBreakAmount:
                            record?.fine?.excessBreakAmount || 1,
                          excessBreakFineAmount:
                            record?.fine?.excessBreakFineAmount /
                            (record?.fine?.excessBreakAmount || 1) || 0,
                          excessBreakHour:
                            record?.fine?.excessBreakFineHoursTime || "00:00",
                          shiftIds: record?.fine?.shiftIds,
                        });
                      }}
                      className={
                        " bg-[white] shadow px-6 py-3 rounded-md w-full md:w-[140px] lg:w-[142px] xl:w-[200px] font-medium text-[#27004a] text-[14px] whitespace-nowrap btns focus:outline-none "
                      }
                    >
                      F I Fine
                    </button>

                    {/* Modal overlay and content */}
                    {isOpen0 && (
                      <div className="z-50 fixed inset-0 flex justify-center items-center bg-[#00000010] p-[10px]">
                        <div className="bg-white shadow-lg p-6 rounded-lg w-full max-w-lg h-[100%] overflow-y-scroll scroll-bar-design">
                          <div className="">
                            <div className="mb-[20px]">
                              <h2 className="font-semibold text-[18px] text-[black] text-xl">
                                {" "}
                                Fine{" "}
                              </h2>
                              <p className="text-[14px]">
                                {selectedStaff?.name} {formatDate(date)} I{" "}
                              </p>
                            </div>
                            <div>
                              <label className="block mb-1 text-[#000] text-sm">
                                Shift Name
                              </label>
                              <div className="relative">
                                <select
                                  value={fine.shiftIds}
                                  onChange={(e) => {
                                    console.log(e.target.value);
                                    setFine({
                                      ...fine,
                                      shiftIds: e.target.value,
                                    });
                                    console.log(fine);
                                  }}
                                  className="bg-white px-3 py-2 pr-10 border border-gray-200 rounded-md focus:outline-none w-full text-gray-600 appearance-none"
                                >
                                  {allShift.map((shift) => (
                                    <option key={shift.id} value={shift.id}>
                                      {`${shift.shiftName} (${shift.shiftStartTime} - ${shift.shiftEndTime})`}
                                    </option>
                                  ))}
                                </select>
                                <div className="right-0 absolute inset-y-0 flex items-center px-2 pointer-events-none">
                                  <svg
                                    className="w-4 h-4 text-gray-400"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="M19 9l-7 7-7-7"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>{" "}
                          </div>

                          <div className="py-3">
                            <div className="flex justify-between items-center mb-[5px]">
                              <p className="font-medium text-[14px]">
                                Late Entry
                              </p>
                              <CloseIcon className="text-[#89868d] close-icon" />
                            </div>

                            <div className="flex items-center gap-[20px]">
                              <div className="flex flex-col gap-1 w-1/3">
                                <p className="text-[12px]">Hours</p>
                                {/* <p className='pt-[6px] pr-[30px] pb-[6px] pl-[30px] rounded-md text-[14px] select-pe'>00:41      hrs</p> */}
                                <TimePicker
                                  placeholder={fine.lateEntryHour || "00:00"}
                                  showSecond={false}
                                  format="HH:mm"
                                  inputReadOnly
                                  onChange={(time) => {
                                    const value = time
                                      ? time.format("HH:mm")
                                      : "00:00";
                                    const [hours, minutes] = value
                                      .split(":")
                                      .map(Number);
                                    const totalMinutes = hours * 60 + minutes;
                                    setFine({
                                      ...fine,
                                      lateEntryHour: value,
                                      lateEntryFineAmount: (
                                        calculateFinePerMinute(30000, 22, 8) *
                                        totalMinutes
                                      ).toFixed(2),
                                    });
                                  }}
                                  className="xxx"
                                />
                                <p className="text-[12px]">
                                  Amount ₹{" "}
                                  {fine.lateEntryFineAmount *
                                    fine.lateEntryAmount}
                                </p>
                              </div>
                              <div className="flex gap-[20px] w-2/3">
                                <div className="w-1/2">
                                  <select
                                    value={fine.lateEntryAmount}
                                    onChange={(e) =>
                                      setFine({
                                        ...fine,
                                        lateEntryAmount: e.target.value,
                                      })
                                    }
                                    className="pt-[6px] pr-[20px] pb-[6px] border border-[#c9c9c9] rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
                                  >
                                    <option value={1}>1x Salary</option>
                                    <option value={2}>2x Salary</option>
                                  </select>
                                </div>
                                <div className="w-1/2">
                                  <p className="p-[6px] rounded-md w-[124px] text-[14px] select-pe">
                                    ₹ {calculateFinePerMinute(30000, 22, 8)}{" "}
                                    Per Min
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="py-3">
                            <div className="flex justify-between items-center mb-[5px]">
                              <p className="font-medium text-[14px]">
                                Excess Breaks
                              </p>
                              <CloseIcon className="text-[#89868d] close-icon" />
                            </div>

                            <div className="flex items-center gap-[20px]">
                              <div className="flex flex-col gap-1 w-1/3">
                                <p className="text-[12px]">Hours</p>
                                <TimePicker
                                  placeholder={
                                    fine?.excessBreakHour || "00:00"
                                  }
                                  showSecond={false}
                                  format="HH:mm"
                                  inputReadOnly
                                  onChange={(time) => {
                                    const value = time
                                      ? time.format("HH:mm")
                                      : "00:00";
                                    const [hours, minutes] = value
                                      .split(":")
                                      .map(Number);
                                    const totalMinutes = hours * 60 + minutes;
                                    setFine({
                                      ...fine,
                                      excessBreakHour: value,
                                      excessBreakFineAmount: (
                                        calculateFinePerMinute(30000, 22, 8) *
                                        totalMinutes
                                      ).toFixed(2),
                                    });
                                  }}
                                  className="xxx"
                                />
                                <p className="text-[12px]">
                                  Amount ₹{" "}
                                  {fine.excessBreakFineAmount *
                                    fine.excessBreakAmount}
                                </p>
                              </div>
                              <div className="flex gap-[20px] w-2/3">
                                <div className="w-1/2">
                                  <select
                                    value={fine.excessBreakAmount}
                                    onChange={(e) =>
                                      setFine({
                                        ...fine,
                                        excessBreakAmount: e.target.value,
                                      })
                                    }
                                    className="pt-[6px] pr-[20px] pb-[6px] border border-[#c9c9c9] rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
                                  >
                                    <option value={1}>1x Salary</option>
                                    <option value={2}>2x Salary</option>
                                  </select>
                                </div>
                                <div className="w-1/2">
                                  <p className="p-[6px] rounded-md w-[124px] text-[14px] select-pe">
                                    ₹ {calculateFinePerMinute(30000, 22, 8)}{" "}
                                    Per Min
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="py-3">
                            <div className="flex justify-between items-center mb-[5px]">
                              <p className="font-medium text-[14px]">
                                Early Out
                              </p>
                              <CloseIcon className="text-[#89868d] close-icon" />
                            </div>

                            <div className="flex items-center gap-[20px]">
                              <div className="flex flex-col gap-1 w-1/3">
                                <p className="text-[12px]">Hours</p>
                                <TimePicker
                                  placeholder={fine?.earlyOutHour || "00:00"}
                                  showSecond={false}
                                  format="HH:mm"
                                  inputReadOnly
                                  onChange={(time) => {
                                    const value = time
                                      ? time.format("HH:mm")
                                      : "00:00";
                                    const [hours, minutes] = value
                                      .split(":")
                                      .map(Number);
                                    const totalMinutes = hours * 60 + minutes;
                                    setFine({
                                      ...fine,
                                      earlyOutHour: value,
                                      earlyOutFineAmount: (
                                        calculateFinePerMinute(30000, 22, 8) *
                                        totalMinutes
                                      ).toFixed(2),
                                    });
                                  }}
                                  className="xxx"
                                />
                                <p className="text-[12px]">
                                  Amount ₹{" "}
                                  {fine.earlyOutFineAmount *
                                    fine.earlyOutAmount}
                                </p>
                              </div>
                              <div className="flex gap-[20px] w-2/3">
                                <div className="w-1/2">
                                  <select
                                    value={fine.earlyOutAmount}
                                    onChange={(e) =>
                                      setFine({
                                        ...fine,
                                        earlyOutAmount: e.target.value,
                                      })
                                    }
                                    className="pt-[6px] pr-[20px] pb-[6px] border border-[#c9c9c9] rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
                                  >
                                    <option value={1}>1x Salary</option>
                                    <option value={2}>2x Salary</option>
                                  </select>
                                </div>
                                <div className="w-1/2">
                                  <p className="p-[6px] rounded-md w-[124px] text-[14px] select-pe">
                                    {" "}
                                    ₹ {calculateFinePerMinute(
                                      30000,
                                      22,
                                      8
                                    )}{" "}
                                    Per Min
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mt-[10px] mb-[10px]">
                            <span className="text-[12px]">Total Amount</span>
                            <p className="text-[14px]">
                              ₹{" "}
                              {parseFloat(
                                fine.earlyOutFineAmount *
                                fine.earlyOutAmount +
                                fine.lateEntryFineAmount *
                                fine.lateEntryAmount +
                                fine.excessBreakFineAmount *
                                fine.excessBreakAmount
                              ).toFixed(2)}
                            </p>
                          </div>
                          <div className="flex items-center gap-[4px] mb-[20px]">
                            <input type="checkbox" />
                            <p className="text-[14px]">Send SMS to Staff</p>
                          </div>

                          <div className="flex flex-col gap-[10px]">
                            <button
                              disabled={isLoading}
                              onClick={() => {
                                createFine();
                              }}
                              className={
                                "px-4 py-2 bg-[#27004a] text-white rounded-md " +
                                (isLoading &&
                                  "opacity-50 animate-pulse cursor-not-allowed")
                              }
                            >
                              Apply Fine
                            </button>
                            <button
                              onClick={closeModal0}
                              className="bg-[#27004a] px-4 py-2 rounded-md text-white"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="flex md:flex-row lg:flex-row xl:flex-row flex-col md:justify-end lg:justify-end xl:justify-end gap-[20px] w-[50%] md:w-full xl:w-full">

                    {/* Button to open modal */}
                    <button
                      onClick={() => {
                        setDate(record?.punchDate);
                        setPunchId(record?.id);
                        openModal12();
                        setOverTime({
                          ...overTime,
                          lateEntryHour:
                            record?.Overtime?.lateOutOvertimeHoursTime ||
                            "00:00",
                          earlyOutHour:
                            record?.Overtime?.earlyCommingEntryHoursTime ||
                            "00:00",
                          lateEntryFineAmount:
                            record?.Overtime?.lateOutAmount /
                            record?.Overtime?.lateOutOvertimeAmount || 0,
                          lateEntryAmount:
                            record?.Overtime?.lateOutOvertimeAmount || 1,
                          earlyOutFineAmount:
                            record?.Overtime?.earlyCommingEntryAmount || 0,
                          earlyOutAmount:
                            record?.Overtime?.earlyEntryAmount /
                            record?.Overtime?.earlyCommingEntryAmount || 1,
                          shiftIds: record?.Overtime?.shiftIds,
                        });
                        console.log(record);
                      }}
                      className={
                        " bg-[#fff] shadow-md px-6 py-3 rounded-md w-full md:w-[140px] lg:w-[142px] xl:w-[200px] font-medium text-[#000] text-[14px] whitespace-nowrap btns focus:outline-none"
                      }
                    >
                      OT I Overtime
                    </button>

                    {/* Modal overlay and content */}
                    {isOpen12 &&
                      (() => {
                        return (
                          <div className="z-50 fixed inset-0 flex justify-center items-center bg-[#00000010] p-[10px]">
                            <div className="bg-white shadow-lg p-6 rounded-lg w-full max-w-lg h-[100%] overflow-y-scroll scroll-bar-design">
                              <div className="">
                                <div className="mb-[20px]">
                                  <h2 className="font-semibold text-[#27004a] text-[18px]">
                                    {" "}
                                    Overtime Day{" "}
                                  </h2>
                                  <p className="text-[14px]">
                                    {selectedStaff?.name} {formatDate(date)}
                                  </p>
                                </div>

                                <div>
                                  <label className="block mb-1 text-[#000] text-sm">
                                    Shift Name
                                  </label>
                                  <div className="relative">
                                    <select
                                      value={fine.shiftIds}
                                      onChange={(e) =>
                                        setOverTime({
                                          ...overTime,
                                          shiftIds: e.target.value,
                                        })
                                      }
                                      className="bg-white px-3 py-2 pr-10 border border-gray-200 rounded-md focus:outline-none w-full text-gray-600 appearance-none"
                                    >
                                      {allShift.map((shift) => (
                                        <option
                                          key={shift.id}
                                          value={shift.id}
                                        >
                                          {`${shift.shiftName} (${shift.shiftStartTime} - ${shift.shiftEndTime})`}
                                        </option>
                                      ))}
                                    </select>
                                    <div className="right-0 absolute inset-y-0 flex items-center px-2 pointer-events-none">
                                      <svg
                                        className="w-4 h-4 text-gray-400"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth="2"
                                          d="M19 9l-7 7-7-7"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="py-3">
                                <div className="flex justify-between items-center mb-[5px]">
                                  <p className="font-medium text-[14px]">
                                    Late Entry
                                  </p>
                                  <CloseIcon className="text-[#89868d] close-icon" />
                                </div>

                                <div className="flex items-center gap-[20px]">
                                  <div className="flex flex-col gap-1 w-1/3">
                                    <p className="text-[12px]">Hours</p>
                                    <TimePicker
                                      placeholder={
                                        overTime?.lateEntryHour || "00:00"
                                      }
                                      showSecond={false}
                                      format="HH:mm"
                                      onChange={(time) => {
                                        const value = time
                                          ? time.format("HH:mm")
                                          : "00:00";
                                        const [hours, minutes] = value
                                          .split(":")
                                          .map(Number);
                                        const totalMinutes =
                                          hours * 60 + minutes;
                                        setOverTime({
                                          ...overTime,
                                          lateEntryHour: value,
                                          lateEntryFineAmount: (
                                            calculateFinePerMinute(
                                              30000,
                                              22,
                                              8
                                            ) * totalMinutes
                                          ).toFixed(2),
                                        });
                                      }}
                                      className="xxx"
                                    />

                                    <p className="text-[12px]">
                                      Amount ₹{" "}
                                      {parseFloat(
                                        overTime.lateEntryFineAmount *
                                        overTime.lateEntryAmount
                                      ).toFixed(2)}
                                    </p>
                                  </div>
                                  <div className="flex gap-[20px] w-2/3">
                                    <div className="w-1/2">
                                      <select
                                        value={overTime.lateEntryAmount}
                                        onChange={(e) =>
                                          setOverTime({
                                            ...overTime,
                                            lateEntryAmount: e.target.value,
                                          })
                                        }
                                        className="pt-[6px] pr-[20px] pb-[6px] border border-[#c9c9c9] rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
                                      >
                                        <option value={1}>1x Salary</option>
                                        <option value={2}>2x Salary</option>
                                      </select>
                                    </div>
                                    <div className="w-1/2">
                                      <p className="p-[6px] rounded-md w-[124px] text-[14px] select-pe">
                                        ₹{" "}
                                        {calculateFinePerMinute(30000, 22, 8)}{" "}
                                        Per Min
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="py-3">
                                <div className="flex justify-between items-center mb-[5px]">
                                  <p className="font-medium text-[14px]">
                                    Early Out
                                  </p>
                                  <CloseIcon className="text-[#89868d] close-icon" />
                                </div>

                                <div className="flex items-center gap-[20px]">
                                  <div className="flex flex-col gap-1 w-1/3">
                                    <p className="text-[12px]">Hours</p>
                                    <TimePicker
                                      placeholder={
                                        overTime?.earlyOutHour || "00:00"
                                      }
                                      showSecond={false}
                                      format="HH:mm"
                                      inputReadOnly
                                      onChange={(time) => {
                                        const value = time
                                          ? time.format("HH:mm")
                                          : "00:00";
                                        const [hours, minutes] = value
                                          .split(":")
                                          .map(Number);
                                        const totalMinutes =
                                          hours * 60 + minutes;
                                        setOverTime({
                                          ...overTime,
                                          earlyOutHour: value,
                                          earlyOutFineAmount: (
                                            calculateFinePerMinute(
                                              30000,
                                              22,
                                              8
                                            ) * totalMinutes
                                          ).toFixed(2),
                                        });
                                      }}
                                      className="xxx"
                                    />

                                    {/* <p className='pt-[6px] pr-[30px] pb-[6px] pl-[30px] rounded-md text-[14px] select-pe'>00:41      hrs</p> */}
                                    <p className="text-[12px]">
                                      Amount ₹{" "}
                                      {parseFloat(
                                        overTime.earlyOutAmount *
                                        overTime.earlyOutFineAmount
                                      ).toFixed(2)}
                                    </p>
                                  </div>
                                  <div className="flex gap-[20px] w-2/3">
                                    <div className="w-1/2">
                                      <select
                                        value={overTime.earlyOutAmount}
                                        onChange={(e) =>
                                          setOverTime({
                                            ...overTime,
                                            earlyOutAmount: e.target.value,
                                          })
                                        }
                                        className="pt-[6px] pr-[20px] pb-[6px] border border-[#c9c9c9] rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
                                      >
                                        <option value={1}>1x Salary</option>
                                        <option value={2}>2x Salary</option>
                                      </select>
                                    </div>
                                    <div className="w-1/2">
                                      <p className="p-[6px] rounded-md w-[124px] text-[14px] select-pe">
                                        {" "}
                                        ₹{" "}
                                        {calculateFinePerMinute(
                                          30000,
                                          22,
                                          8
                                        )}{" "}
                                        Per Min
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="mt-[10px] mb-[10px]">
                                <span className="text-[12px]">
                                  Total Amount
                                </span>
                                <p className="text-[14px]">
                                  ₹{" "}
                                  {(
                                    parseFloat(
                                      overTime.earlyOutFineAmount *
                                      overTime.earlyOutAmount
                                    ) +
                                    parseFloat(
                                      overTime.lateEntryFineAmount *
                                      overTime.lateEntryAmount
                                    )
                                  ).toFixed(2)}
                                </p>
                              </div>
                              <div className="flex items-center gap-[4px] mb-[20px]">
                                <input type="checkbox" />
                                <p className="text-[14px]">
                                  Send SMS to Staff
                                </p>
                              </div>

                              <div className="flex flex-col gap-[10px]">
                                <button
                                  disabled={isLoading}
                                  onClick={() => {
                                    createOvertime();
                                  }}
                                  className={
                                    "px-4 py-2 bg-[#27004a] text-white rounded-md " +
                                    (isLoading &&
                                      "opacity-50 animate-pulse cursor-not-allowed")
                                  }
                                >
                                  Apply Overtime
                                </button>
                                <button
                                  onClick={closeModal12}
                                  className="bg-[#27004a] px-4 py-2 rounded-md text-white"
                                >
                                  Cancel
                                </button>
                              </div>
                            </div>
                          </div>
                        );
                      })()}
                    {/* Button to open modal */}
                    <button
                      onClick={() => {
                        setPunchId(record?.id);
                        setCommonStatus("PAIDLEAVE");
                      }}
                      className={
                        "bg-[#fff] shadow-md px-6 py-3 rounded-md w-full md:w-[140px] lg:w-[142px] xl:w-[200px] font-medium text-[#000] text-[14px] whitespace-nowrap btns focus:outline-none" +
                        (record?.status === "PAIDLEAVE"
                          ? "bg-[#008000] text-white"
                          : "bg-white text-black")
                      }
                    >
                      L I Paid Leave
                    </button>
                    {/* Button to open modal */}
                    <button
                      onClick={() => {
                        setPunchId(record?.id);
                        setCommonStatus("ABSENT");
                      }}
                      className={
                        "shadow-md px-6 py-3 rounded-md w-full md:w-[140px] lg:w-[142px] xl:w-[200px] font-medium text-[14px] whitespace-nowrap btns focus:outline-none " +
                        (record?.status === "ABSENT"
                          ? "bg-[#ff0000] text-white"
                          : "bg-white text-black")
                      }
                    >
                      A I Absent
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      )}
      {
        attendanceRecord?.length === 0 && isLoading === true && (
          <div className="flex justify-center items-center py-4">
            <ClipLoader color="#27004a" size={60} />
          </div>
        )
      }
    </div>
  );
};
export default StaffSalarySummry;







